import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Button, Icon } from '@shared/widgets';
import CrossIcon from '@assets/icons/cross.svg';

interface IRemoveUserItemProps {
  className?: string;
  firstName: string;
  removeItems: () => void;
}

export const RemoveUserItem = (props: IRemoveUserItemProps) => {
  return (
    <div className={clsx('max-w-fit mb-2 p-3 pl-6 rounded-sm bg-ice dark:bg-dark-ice-white flex items-center', props.className)}>
      <div className='min-w-0 pr-2 shrink'>
        <div className='min-w-0 flex items-center shrink'>
          <div className='w-12 h-12 mr-3 rounded-full flex-none flex items-center justify-center text-center relative select-none overflow-hidden'>
            <div
              className={clsx(
                'w-full h-full min-w-0 min-h-0 rounded-[inherit] bg-primary flex items-center justify-center text-center font-medium text-xl relative z-10',
                PaletteUtils.isInsigniaPalette && 'text-soft-black',
                PaletteUtils.isVcfcPalette && 'text-white',
              )}
            >
              {props.firstName.split('')[0]}
            </div>
          </div>
          <div className='min-w-0 m-0 py-1 flex-auto'>
            <div className='overflow-hidden text-ellipsis font-medium text-xl '>{props.firstName}</div>
          </div>
        </div>
      </div>
      <Button color='icon' className='w-6 h-5 !p-0' onClick={props.removeItems}>
        <Icon icon={<CrossIcon width='24' height='24' />} color='red' />
      </Button>
    </div>
  );
};
